import { withInstall } from '@vuemap/vue-amap-util'
import HeatMap from './HeatMap.vue'

export const ElAmapLayerHeatMap = withInstall(HeatMap)
export default ElAmapLayerHeatMap
